import {
    GET_FREIGHT_TERM_REQUEST,
    GET_FREIGHT_TERM_SUCCESS,
    GET_FREIGHT_TERM_ERROR,
    ADD_FREIGHT_TERM_ERROR,
    ADD_FREIGHT_TERM_REQUEST,
    ADD_FREIGHT_TERM_SUCCESS,
    UPDATE_FREIGHT_TERM_ERROR,
    UPDATE_FREIGHT_TERM_REQUEST,
    UPDATE_FREIGHT_TERM_SUCCESS,
    DELETE_FREIGHT_TERM_ERROR,
    DELETE_FREIGHT_TERM_REQUEST,
    DELETE_FREIGHT_TERM_SUCCESS

} from "./types"
import axios from "axios";
import { BASEURL } from "../../constant/config.js"



export const loadFreightTerm = (token) => dispatch => {
    dispatch({ type: GET_FREIGHT_TERM_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/adminFreightTerm`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => {
            return dispatch({ type: GET_FREIGHT_TERM_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_FREIGHT_TERM_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_FREIGHT_TERM_ERROR,
                payload: error.response,
            });
        })
};



export const addFreightTerm = (token, data, id) => (dispatch) => {
    dispatch({ type: ADD_FREIGHT_TERM_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}create/adminFreightTerm`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data,
    })
        .then((response) => {
            return dispatch({ type: ADD_FREIGHT_TERM_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: ADD_FREIGHT_TERM_ERROR,
                payload: error.response,
            });
        });
};



export const updateFreightTerm = (token, data, id) => (dispatch) => {
    dispatch({ type: UPDATE_FREIGHT_TERM_REQUEST });
    return axios({
        method: "PUT",
        url: `${BASEURL}update/adminFreightTerm/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data,
    })
        .then((response) => {
            return dispatch({ type: UPDATE_FREIGHT_TERM_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: UPDATE_FREIGHT_TERM_ERROR,
                payload: error.response,
            });
        });
};



export const deleteFreightTerm = (token, id) => (dispatch) => {
    dispatch({ type: DELETE_FREIGHT_TERM_REQUEST });
    return axios({
        method: "DELETE",
        url: `${BASEURL}delete/adminFreightTerm/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((response) => {
            return dispatch({ type: DELETE_FREIGHT_TERM_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: DELETE_FREIGHT_TERM_ERROR,
                payload: error.response,
            });
        });
};
